import React, { useState, useEffect } from 'react';
import * as ReactIcons from "react-icons/fa";
import { IconContext } from "react-icons";
import './styles.css';

const FlatDropdown = ({data, setUserSubCategory, value}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState('');
  const [dataItems,  setDataItems] = useState([])

  useEffect(()=>{
    setDataItems(data);
  },[data, isOpen])

  // useEffect(()=>{
  //   setUserSubCategory(selectedItem?.subCategoryName);
  // },[selectedItem]);


  const toggleDropdown = () => {  
    setIsOpen(!isOpen);
  };

  const handleItemClick = (item) => {
    setSelectedItem(item);
    setUserSubCategory(item?.subCategoryName)
    setIsOpen(false);
  };

  const IconComponent = ReactIcons["FaAngleDown"];
  
  return (
    <div className="dropdown-container">
       <div className = "subcategory-container" onClick={toggleDropdown} >
          <div className="dropdown-header" >
            {value?.length > 0 ?  value :selectedItem ? selectedItem?.subCategoryName: 'Select'}
          </div>
          <div className="dropdown-icon-container">
            <IconContext.Provider
            value={{ color: "#588fe8", size: 15 }}
            >
            <IconComponent />
            </IconContext.Provider>
            </div>
        </div>
      {isOpen && dataItems?.length > 0 ?  (
        <ul className="dropdown-menu">
          {
            dataItems.map((item) => { 
              return  <li key={item?.id} onClick={(event) => handleItemClick(item)}>{item?.subCategoryName}</li>
            })
          }
        
        </ul>
      ) : null }
    </div>
  );
};

export default FlatDropdown;
